module.exports = __webpack_public_path__ + "img/fiveday1-2.3e0dd0cf.jpg";